// import { Link } from 'react-router-dom'
import React from 'react'
import Bradcom from '../Bradcom/Main'
import BookingArea from '../Menhome/BookingArea'
import RoomTable from '../Menhome/RoomTable'

const Main = () => {
  return (
    <>
        <main>
            <Bradcom title={"Reserva"} subtitle={"Inicio"} newtitle={"Reserva"}/>
            <BookingArea/>
           <RoomTable/>           
        </main>
     
    </>
  )
}

export default Main